import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5b883a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-question" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"add-q-title\" data-v-b5b883a8>添加问题</p><p class=\"add-q-tips\" data-v-b5b883a8><i class=\"icon iconfont icon-a-Group14379\" data-v-b5b883a8></i>25/1-3个问题，问题数量超过3个按 <i class=\"icon iconfont icon-a-Group14379\" data-v-b5b883a8></i>10/1个问题计算 </p><p class=\"add-q-title\" data-v-b5b883a8>问题描述</p><p class=\"add-q-title-tip\" data-v-b5b883a8></p>", 4)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-q-title" }, "上传图片", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao1" }, null, -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "yellow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_form, { model: _ctx.question }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.question.info,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question.info) = $event)),
              modelModifiers: { trim: true },
              type: "textarea",
              rows: 4,
              placeholder: "请详细描述你的问题，以便我们做出回答（不少于15字）"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _hoisted_6,
        _createVNode(_component_el_upload, {
          "file-list": _ctx.fileList,
          "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
          action: "",
          "list-type": "picture-card",
          "on-preview": _ctx.handlePictureCardPreview,
          accept: ".jpg,.jpeg,.png",
          limit: 3,
          "before-upload": _ctx.beforeUpload,
          "on-change": _ctx.handleProgress,
          class: _normalizeClass({ nonejiahao: _ctx.fileList.length >= 3 })
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["file-list", "on-preview", "before-upload", "on-change", "class"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              "w-full": "",
              src: _ctx.dialogImageUrl,
              alt: "Preview Image"
            }, null, 8, _hoisted_8)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _ctx.addQuestion,
            type: "primary",
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}